import { PlaceOfServiceCode } from 'services/constants';

export const SubmissionTypes = {
    ESTIMATE: 'ESTIMATE',
    ADJUDICATE: 'ADJUDICATE',
} as const;
export type SubmissionType = (typeof SubmissionTypes)[keyof typeof SubmissionTypes];

const mapToOptions = (map: Record<string, string>) =>
    Object.entries(map).map(([key, value]) => ({ name: value, secondaryData: key, value: key }));

export const ClaimPlaceOfServiceMap = {
    '11': 'Office',
    '12': 'Home',
    '21': 'Inpatient Hospital',
    '22': 'Outpatient Hospital',
    '23': 'Emergency Room - Hospital',
} as const;
export const ClaimPlaceOfServiceOptions = mapToOptions(ClaimPlaceOfServiceMap).filter(
    // Only allow '11' and '12' to be entered in the UI
    ({ secondaryData }) => ['11', '12'].includes(secondaryData),
);

export const ClaimPlaceOfServiceReferralPlaceOfServiceMap = {
    '11': PlaceOfServiceCode.PHYS_SPEC,
    '12': PlaceOfServiceCode.HOME,
    '21': PlaceOfServiceCode.FACILITY,
    '22': PlaceOfServiceCode.FACILITY,
    '23': PlaceOfServiceCode.FACILITY,
} as const;

export const ClaimUomMap = {
    F2: 'International Units',
    GR: 'Grams',
    ME: 'Milligrams',
    ML: 'Milliliters',
    UN: 'Units',
} as const;

export const ClaimFrequencyTypes = {
    ORIGINAL: '1',
    RESUBMIT: '7',
    VOID: '8',
} as const;
export type ClaimFrequencyType = (typeof ClaimFrequencyTypes)[keyof typeof ClaimFrequencyTypes];

export const ClaimFrequencyTypeDisplayTextMap = {
    [ClaimFrequencyTypes.ORIGINAL]: 'Original',
    [ClaimFrequencyTypes.RESUBMIT]: 'Resubmit',
    [ClaimFrequencyTypes.VOID]: 'Void',
} as const;

export const ClaimFrequencyTypeOptions = mapToOptions(ClaimFrequencyTypeDisplayTextMap);

export const ClaimFrequencyTypeIconDisplayTextMap = {
    [ClaimFrequencyTypes.ORIGINAL]: 'Original Claim',
    [ClaimFrequencyTypes.RESUBMIT]: 'Revised Claim',
    [ClaimFrequencyTypes.VOID]: 'Voided Claim',
} as const;
